import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./page.css";
import "./home.css";

function Trips() {
  useEffect(() => {
    document.title = "Trips · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <p className="eyebrow">Trips</p>
            <h1 className="mb-3">Custom trips built around Zanzibar.</h1>
            <p className="page-lead mb-4">
              Flexible itineraries for couples, families, and small groups.
            </p>
            <Link className="btn btn-mk-gold" to="/contact">
              Plan a trip
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trips;
